var _defs, _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNerkhSeke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.87 37.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5bd18;\n      }\n\n      .cls-2 {\n        fill: #b4d569;\n      }\n\n      .cls-3 {\n        fill: #27b173;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.97,37.9c-7.15,0-12.97-5.82-12.97-12.97S5.82,11.97,12.97,11.97s12.97,5.82,12.97,12.97-5.82,12.97-12.97,12.97Zm0-24.94c-6.6,0-11.97,5.37-11.97,11.97s5.37,11.97,11.97,11.97,11.97-5.37,11.97-11.97-5.37-11.97-11.97-11.97Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.4,32.21c-7.43,0-13.47-6.04-13.47-13.47s6.04-13.47,13.47-13.47,13.47,6.04,13.47,13.47-6.04,13.47-13.47,13.47Zm0-24.94c-6.32,0-11.47,5.14-11.47,11.47s5.14,11.47,11.47,11.47,11.47-5.14,11.47-11.47-5.14-11.47-11.47-11.47Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.13,
    cy: 12.47,
    r: 12.47
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNerkhSeke);
export default __webpack_public_path__ + "static/media/nerkh-seke.7751abba8ff5ffa47f2d2741e557ef62.svg";
export { ForwardRef as ReactComponent };